import usePageTitle from "@/hooks/usePageTitle";
import { useParams, useNavigate } from "react-router-dom";
import EditJobPostForm from "@/components/Forms/JobPostForm/EditJobPostForm";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";

export default function EditJobPostPage() {
  useRequireCapability({ domain: DOMAIN.JOBS, permission: PERMISSION.manageJobPosts });
  usePageTitle("Section | Jobs | Edit Job Post");
  const { sectionId, jobPostId } = useParams();
  const navigate = useNavigate();

  if (!sectionId || !jobPostId) {
    navigate("/");
    return null;
  }

  const handleSuccess = (id: string) => {
    navigate(`/sections/${sectionId}/jobs/job-post/${id}/details`);
  };

  return <EditJobPostForm jobPostId={jobPostId} sectionId={sectionId} onSuccess={handleSuccess} />;
}
